import { CircularProgress, Box,Button,Container } from "@material-ui/core";
import useStyles from "../components/Styles/ShowProjectStyles";

export default function Pagination({isLoading,handleClick}: any) {
const classes = useStyles();
  return (
    <Box className={classes.projectspages} mt={3} component="section">
      <Container fixed>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          className=""
        >
          <Button
            onClick={handleClick}
            variant="outlined"
            className="loadingBtn "
          >
            {
              isLoading
                ? "Loading"
                : "Show More"
            }&nbsp;
            {isLoading && (
              <CircularProgress
                className="m-class"
                variant="indeterminate"
                size={10}
                thickness={2}
                color="secondary"
              />
            )}
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
